import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["RAG", "LLMs", "FastAPI", "React", "Playwright", "Vector Search", "Automation", "Next.js", "Python", "API Testing", "Docker", "PostgreSQL", "Qdrant", "SQL Agents"];

export default function KeywordMarquee() {
    return (
        <section className="py-10 border-y border-border overflow-hidden" data-testid="marquee">
            <Marquee speed={40} gradient={false} pauseOnHover>
                {WORDS.concat(WORDS).map((w, i) => (
                    <span key={i} className="mx-8 font-display text-3xl sm:text-5xl font-light text-muted-foreground/40 flex items-center gap-8">
                        {w} <span className="text-primary/40 text-xl">✦</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
